/// <amd-module name="SuiteCommerce.ProductLeadTime.Shopping"/>
define("SuiteCommerce.ProductLeadTime.Shopping", ["require", "exports", "SuiteCommerce.ProductLeadTime.Common.Configuration", "SuiteCommerce.ProductLeadTime.PDP", "SuiteCommerce.ProductLeadTime.Instrumentation.Helper"], function (require, exports, Configuration_1, PDP, Instrumentation_Helper_1) {
    "use strict";
    return {
        mountToApp: function (container) {
            var environment = container.getComponent('Environment');
            this.initializeConfiguration(environment);
            this.initializeInstrumentation(container);
            PDP.mountToApp(container);
        },
        initializeConfiguration: function (environment) {
            Configuration_1.Configuration.environment = environment;
        },
        initializeInstrumentation: function (container) {
            Instrumentation_Helper_1.InstrumentationHelper.initializeInstrumentation(container);
        },
    };
});
